module.exports = __webpack_public_path__ + "static/media/address.3a9c005c.svg";